import { message } from 'antd';
import { replace } from 'connected-react-router';
import { call, fork, put, take } from 'redux-saga/effects';
import translations from 'translations';
import { checkValidEmail, getListSalesPic, signup } from 'utils/apollo';
import utilsMessages from 'utils/messages';
import { checkEmail as checkEmailActions, getListSalesPicSuccess, signup as signupActions } from './actions';
import ActionTypes from './constants';

function* signupFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.SIGNUP_SUBMIT);
    payload.lang = localStorage.getItem('lang') || 'vi';
    yield put(signupActions.request());
    delete payload.confirmPassword;
    delete payload.provinceId;
    delete payload.districtId;

    const response = yield call(signup, {
      input: payload,
    });

    if (!response.errors) {
      yield put(signupActions.success(response));
      message.success(translations(utilsMessages.accountCreatedSuccessfully));
      yield put(replace('/kamereo-internal-signup', { success: true }));
    } else {
      yield put(signupActions.failure(response.errors));
      response.errors.map((e: any) => message.error(e.message));
    }
  }
}

function* checkEmailFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.CHECK_EMAIL_SUBMIT);
    yield put(checkEmailActions.request());
    const response = yield call(checkValidEmail, {
      email: payload,
    });
    if (!response.errors) {
      const errorMessage = response?.userErrors?.[0]?.message || '';
      yield put(checkEmailActions.success(errorMessage));
    } else {
      yield put(checkEmailActions.failure(response.errors[0].message));
    }
  }
}

function* getListSalesPicData() {
  const response = yield call(getListSalesPic, {
    salesIds: [],
  });
  if (!response.errors) {
    yield put(getListSalesPicSuccess(response.data));
  }
}

// Individual exports for testing
export default function* signupPageSaga() {
  // See example in containers/HomePage/saga.js
  yield call(getListSalesPicData);
  yield fork(signupFlow);
  yield fork(checkEmailFlow);
}
